import { messageCatalogs, type AppLocale, type MessageTree } from "@airange/shared/i18n-exam-admin";
import routeConfig from "../app/routes";

type RouteLocaleNode = {
  name?: string;
  routes?: RouteLocaleNode[];
};

function flattenMessageTree(tree: MessageTree, prefix = ""): Record<string, string> {
  return Object.entries(tree).reduce<Record<string, string>>((result, [key, value]) => {
    const nextPrefix = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      result[nextPrefix] = value;
      return result;
    }
    return {
      ...result,
      ...flattenMessageTree(value, nextPrefix),
    };
  }, {});
}

function collectRouteMessageKeys(routes: readonly RouteLocaleNode[]): Set<string> {
  return routes.reduce<Set<string>>((result, route) => {
    if (route.name) {
      result.add(route.name);
      result.add(`menu.${route.name}`);
    }
    if (route.routes?.length) {
      collectRouteMessageKeys(route.routes).forEach((key) => result.add(key));
    }
    return result;
  }, new Set<string>());
}

const routeMessageKeys = collectRouteMessageKeys(routeConfig as RouteLocaleNode[]);

export function buildUmiLocaleMessages(locale: AppLocale) {
  const flatMessages = flattenMessageTree(messageCatalogs[locale]);
  const routeMessages = Object.fromEntries(
    Array.from(routeMessageKeys).map((messageKey) => {
      const sourceKey = messageKey.startsWith("menu.") ? messageKey.slice("menu.".length) : messageKey;
      return [messageKey, flatMessages[sourceKey] ?? sourceKey];
    }),
  );
  return {
    ...flatMessages,
    ...routeMessages,
  };
}
